import { VFlow } from 'bold-ui'

import { NewsHeadingSection } from '../components/NewsHeadingSection'
import { NewsListItem } from '../components/NewsListItem'

export function NewsInternalEstabilizacaoV55() {
  return (
    <VFlow>
      <NewsHeadingSection title='Versão 5.5.21' id='estabilizacao-5-5-21'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Ajustes na retificação do atendimento de procedimentos para garantir o correto tratamento de procedimentos
            SIGTAP e AB inativos.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário na vacinação (CDS) para permitir o registro da vacina Covid-19 (Moderna – Spikevax) com
            a estratégia Campanha Indiscriminada e dose de reforço (REV).
          </NewsListItem>
          <NewsListItem>
            Correção na Busca Ativa de Vacinação para que a segunda dose da vacina Pneumo 20 não seja considerada
            atrasada quando houver o registro equivalente da segunda dose da Pneumo 10.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário na vacinação (CDS) que impedia a edição das informações gerais da ficha de vacinação
            após o registro da vacina BCG, devido à exibição incorreta de obrigatoriedade do campo Comunicante de
            hanseníase.
          </NewsListItem>
          <NewsListItem>
            Ajuste no módulo de Vacinação para remover o campo pesquisa na transcrição de caderneta e renomeá-lo para
            pesquisa clínica nos registros de aplicação de vacinas.
          </NewsListItem>
          <NewsListItem>
            Inclusão do fabricante "LIBBS FARMACÊUTICA LTDA." na lista de fabricantes para aplicação de imunobiológicos
            do sistema.
          </NewsListItem>
          <NewsListItem>
            Correção no botão Limpar do Registro Tardio para remover corretamente todas as informações do cidadão
            selecionado.
          </NewsListItem>
          <NewsListItem>
            Atualização das regras de equivalência entre as doses de reforço das vacinas Poliomielite Inativada (VIP) e
            Poliomielite Oral (VOP) na aplicação de imunobiológicos e na Busca Ativa de Vacinação.
          </NewsListItem>
          <NewsListItem>
            Inclusão de novos itens para seleção nos campos de Tema para reunião e Público-alvo do registro de Atividade
            coletiva.
          </NewsListItem>
          <NewsListItem>
            Inclusão de uma notificação ao participante que permanecer na videochamada após o outro participante
            encerrar sua participação.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
    </VFlow>
  )
}
